// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
// THIS BREAKS THE AUTH (Emergent Google OAuth derives redirect from window.location)
import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await fetch(`${API_URL}/api/auth/me`, { credentials: 'include' });
      if (r.ok) setUser(await r.json());
      else setUser(null);
    } catch (err) {
      // Non-fatal : network offline or /me not reachable. Treat as anonymous.
      console.warn('[Auth] /me check failed:', err?.message || err);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: if returning from OAuth callback, skip /me. AuthCallback will exchange.
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    try {
      await fetch(`${API_URL}/api/auth/logout`, { method: 'POST', credentials: 'include' });
    } catch (err) {
      console.warn('[Auth] logout POST failed (still clearing local user):', err?.message || err);
    }
    setUser(null);
  }, []);

  // Stable context value : avoids re-rendering every consumer on each render.
  const contextValue = useMemo(
    () => ({ user, setUser, loading, refresh: checkAuth, logout }),
    [user, loading, checkAuth, logout],
  );

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
